import { HTMLAttributes } from 'react';

import { cn } from './cn';

export type StatusBadgeTone =
  | 'neutral'
  | 'brand'
  | 'positive'
  | 'caution'
  | 'critical'
  | 'informative'
  | 'gold'
  | 'silver'
  | 'bronze';

const toneClassNames: Record<StatusBadgeTone, string> = {
  neutral: 'border-line bg-canvas text-ink-muted',
  brand: 'border-brand/20 bg-brand-subtle text-brand',
  positive: 'border-positive/20 bg-positive-subtle text-positive',
  caution: 'border-caution/20 bg-caution-subtle text-caution-ink',
  critical: 'border-critical/20 bg-critical-subtle text-critical',
  informative: 'border-informative/20 bg-informative-subtle text-informative',
  gold: 'border-gold/30 bg-gold-subtle text-gold-ink',
  silver: 'border-silver/30 bg-silver-subtle text-silver-ink',
  bronze: 'border-bronze/30 bg-bronze-subtle text-bronze-ink',
};

export interface StatusBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusBadgeTone;
}

export const StatusBadge = ({ className, tone = 'neutral', ...props }: StatusBadgeProps) => (
  <span
    className={cn(
      'inline-flex min-h-5 items-center rounded-full border px-2 py-0.5 text-xs font-medium leading-none',
      toneClassNames[tone],
      className,
    )}
    {...props}
  />
);
